document.addEventListener("DOMContentLoaded", function (event) {
  $('.klaviyo_submit_button').on('click', function (e) {
    let consentArray = {
      '$email': $('input#k_id_email').val()
    };
    $('.newsletter-privacy-wrap input:checked').each(function () {
      let item = '' + $(this).val();
      consentArray[item] = 'Yes';
    });

    function klaviyoPrivacy() {
      var klaviyoPrivacy = $('#consent-klaviyo').val();
      var consentPrivacy = $('#consent-privacy').val();
      consentArray[klaviyoPrivacy] = consentPrivacy;
    }

    function klaviyoConsent() {
      var kvaviyoConsentName = $("#consent-title").val();
      var kvaviyoConsentValue = $("#consent-value").val();
      consentArray[kvaviyoConsentName] = kvaviyoConsentValue;
    }

    function klaviyoAccepts() {
      var kvaviyoAcceptsName = $("#accepts-title").val();
      var kvaviyoAcceptsValue = $("#accepts-value").val();
      consentArray[kvaviyoAcceptsName] = kvaviyoAcceptsValue;
    }

    klaviyoPrivacy();
    klaviyoConsent();
    klaviyoAccepts();
    function onIdentifyCompleteCallback() {
      _learnq.push(['identify', consentArray]);
      _learnq.push(['identify', klaviyoPrivacy()]);
      _learnq.push(['identify', klaviyoConsent()]);
      _learnq.push(['identify', klaviyoAccepts()]);
    };

      _learnq.identify({
      '$email': $('input#k_id_email').val()
    }, undefined, undefined, onIdentifyCompleteCallback);
  });
});

function isChecked() {
  let privacyCheckbox = document.querySelector(".newsletter-privacy-input");
  let btnMob = document.querySelector(".newsletter__btn--mob");
  let btnDesc = document.querySelector(".newsletter__btn--desk");

  privacyCheckbox.addEventListener("change", () => {
    if (privacyCheckbox.checked) {
      btnMob.disabled = false;
      btnDesc.disabled = false;
      btnMob.style.opacity = "1";
      btnDesc.style.opacity = "1";
      btnMob.style.cursor = "pointer";
      btnDesc.style.cursor = "pointer";
    } else {
      btnMob.disabled = true;
      btnDesc.disabled = true;
      btnMob.style.opacity = "0.5";
      btnDesc.style.opacity = "0.5";
      btnMob.style.cursor = "not-allowed";
      btnDesc.style.cursor = "not-allowed";
    }
  });
}

isChecked();

KlaviyoSubscribe.attachToForms('#email_signup', {
  hide_form_on_success: true,
  success_message: "<div>Grazie,</div><div>riceverai a breve una email per confermare la tua iscrizione.</div>",
  extra_properties: {
  $source: '$embed',
  $method_type: "Newsletter Form",
  $method_id: 'embed',
  $consent_version: 'Embed default text'
}
});
